import React from "react";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

const BarChart = ({ userData }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip:{
        backgroundColor:"whitesmoke",
        bodyColor:"#000",
        titleColor:"#000",
        padding:"10",
        titleFont:"bold",
        titleAlign:"center",
        bodyAlign:"center"
      },
      datalabels: {
        display: true,
        color: "#fff",
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 20,
        },
      },
    },
  };

  const getMonth = (date) => {
    const inputDate = new Date(date);
    const options = { month: "short" };
    return inputDate.toLocaleDateString("en-US", options);
  };

  const labels = userData?.totalUsersByMonth?.map((data) =>
    getMonth(data?.date_trunc)
  );

  const userCount = userData?.totalUsersByMonth?.map((data) =>
    parseInt(data.count)
  );

  const data = {
    labels,
    datasets: [
      {
        label: "User signup",
        data: userCount,
        backgroundColor: "rgba(4, 69, 157)",
        hoverBackgroundColor:"#72A0C1"
      },
    ],
  };

  return <Bar width={300} height={300} options={options} data={data} />;
};

export default BarChart;
